import { Component, OnDestroy, OnInit } from '@angular/core';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { LocalStorageService } from '../../services/local-storage.service';
import { Router } from '@angular/router';
import { CommonExternalModule } from '../../common/common-external-module';
import { ProductService } from '../../services/product.service';
import { HeaderComponent } from '../../components/header/header.component';

@Component({
  selector: 'app-payment-success',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent],
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.css'
})
export class PaymentSuccessComponent implements OnInit, OnDestroy {

  googleCustomer: GoogleCustomer;

  constructor(
    private localStorage: LocalStorageService,
    private navRoute: Router,
    public productService: ProductService
  ) {
    console.log(this.navRoute.getCurrentNavigation().extras.state);
    if (this.navRoute.getCurrentNavigation().extras.state != undefined) {
      this.navRoute.getCurrentNavigation().extras.state = undefined;
      window.location.reload();
    }
  }

  ngOnInit() {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
  }

  ngOnDestroy(): void {

  }

  go() {
    this.navRoute.navigate(["/"]);
  }

  download() {
    this.navRoute.navigate(["/invoice-history"]);
  }
}